import { inject } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { switchMap, take, combineLatest } from 'rxjs';
import { AuthenticationService } from '@auth/services/authentication.service';
import { HttpInterceptorFn } from '@angular/common/http';
import { UserInformationService } from '@core/services/user-data/user-data.service';

export const SmartClientInterceptor: HttpInterceptorFn = (req, next) => {
  const _authenticationService = inject(AuthenticationService);
  const _oidcSecurityService = inject(OidcSecurityService);
  const userService = inject(UserInformationService);

  if (req.url.includes('smartclientapi')) {
    return _authenticationService.isAuthenticated$.pipe(
      take(1),
      switchMap((isAuthenticated) => {
        if (isAuthenticated) {
          return combineLatest([
            _oidcSecurityService.getAccessToken(),
            userService.selectedOrgCode.pipe(take(1)),
            userService.userProfileData.pipe(take(1)),
          ]).pipe(
            switchMap(([accessToken, orgCode, userData]) => {
              let modifiedRequest = req.clone({
                setHeaders: {
                  Authorization: `${accessToken}`,
                },
              });

              // Add orgCode and userId to the request body if possible
              if (req.body) {
                let body: FormData | Record<string, unknown>;

                if (req.body instanceof FormData) {
                  // Handle FormData
                  body = new FormData();
                  req.body.forEach((value, key) => {
                    (body as FormData).append(key, value);
                  });

                  if (orgCode) body.append('orgCode', orgCode);
                  if (userData?.userName) body.append('userId', userData.userName);
                } else {
                  // Handle JSON body
                  body = req.body instanceof Object ? { ...req.body } : {};
                  if (orgCode) body['orgCode'] = orgCode;
                  if (userData?.userName) body['userId'] = userData.userName;
                }

                modifiedRequest = modifiedRequest.clone({ body });
              }

              return next(modifiedRequest);
            }),
          );
        } else {
          console.error('User is not authenticated.');
          return next(req);
        }
      }),
    );
  } else {
    return next(req);
  }
};
